import { sectionAPI } from '../services/sectionAPI';
import { $Q, $Qll, isMobile } from '../utils/query-selector';
import { stringToHTML } from '../utils/to-html';
import { variantOnChange } from './variants-product';
import { dataToggle, toggleDataActive } from '../utils/toggle-dataset';
import { openAccordion } from '../utils/accordion';
import { rangeFilters } from './range-input';
import { render } from '../utils/render';
import { Loader } from './loader';
import { btnAddToCart } from './cart';
import { setupCustomSelect } from './custom-select';

/**
 * Get params range price selected
 * @returns Array data
 */
const getParamsRange = () => {
  let rangeParams = [];
  $Qll('.price-in input').forEach((input) => {
    if (input.value) {
      rangeParams = [...rangeParams, { name: input.name, value: input.value }];
    }
  });

  return rangeParams;
};

/**
 * Get param of sorting selected
 * @returns String data
 */
const getParamSort = () => {
  const sortParam = $Q('.sort-options[name="sortOptions"]:checked');
  return sortParam ? `&sort_by=${sortParam.value}` : '';
};

/**
 * Get params checkbox selected all
 * @returns Array data
 */
const getParamsChecked = () => {
  let checkedParams = [];
  $Qll('.input-check').forEach((params) => {
    if (params.checked) {
      checkedParams = [
        ...checkedParams,
        { name: params.name, value: params.value },
      ];
    }
  });

  return checkedParams;
};

/**
 * Reinitialize function event js
 */
const restartEvents = (query) => {
  variantOnChange('.variants');
  openAccordion();
  initFilterCollections();
  setupCustomSelect();

  if (query) dataToggle($Q('#filter'), false);
};

/**
 * Reset clear element
 */
const restarClearChange = () => {
  $Qll('.clear-filter-js').forEach((element) => {
    // eslint-disable-next-line no-param-reassign
    element.checked = false;
  });
};

/**
 * Render products section based on filters
 * @param {String} query - data all prams slected in
 * order with name form filtering
 */
const renderSectionFetch = async (query) => {
  // Show loader. When the component is rendered, this is hidden
  render(new Loader(), $Q('.collection'));

  const URL = `${window.location.pathname}?${query}`;

  const section = await sectionAPI(URL, 'collection');
  const sectionFilter = await sectionAPI(URL, 'collection-filters');
  const contentRenderCollections = $Q('#list-products', stringToHTML(section));
  const contentRenderFilter = $Q(
    '.filter-container',
    stringToHTML(sectionFilter)
  );
  // const totalItems = ontentRenderCollections.getAttribute('data-total');

  $Q('.collection').innerHTML = contentRenderCollections.innerHTML;
  $Q('#filter').outerHTML = contentRenderFilter.outerHTML;

  // Show or hide empty view
  if (
    $Qll('.grid--center .grid__cell', contentRenderCollections).length === 0
  ) {
    $Q('#empty-colection-view').classList.remove('hidden');
  } else {
    $Q('#empty-colection-view').classList.add('hidden');
  }

  restartEvents(query);

  if (query) restarClearChange();

  btnAddToCart('.add-product-cart');
};

/**
 *preparing filter... get the parameterized data in the filter
 */
const prepareFilteringParameter = () => {
  const paramsCheck = getParamsChecked();
  const paramsRange = getParamsRange();
  const paramsSort = getParamSort();

  const queryParams = paramsCheck
    .concat(paramsRange)
    .map((query) => `${query.name}=${query.value}`)
    .join('&');

  renderSectionFetch(`${queryParams}${paramsSort}`);
};

/**
 * add event form submit filterin form
 */
const addEventClickFiltering = () => {
  toggleDataActive('.filter__form--name svg', '#filter', {
    overlay: false,
  });

  // Listener for Buttons
  $Qll('.submit-filter').forEach((button) => {
    button.addEventListener('click', () => {
      prepareFilteringParameter();
    });
  });

  $Qll('.sort-options').forEach((input) => {
    input.addEventListener('change', () => {
      prepareFilteringParameter();
    });
  });

  // Listener for inputs
  if (!isMobile()) {
    $Qll('.input-check').forEach((input) => {
      input.addEventListener('change', () => {
        prepareFilteringParameter();
      });
    });
  }
};

/**
 * Clear all selected filters
 */
const clearFilterAll = async () => {
  await renderSectionFetch('');
  $Qll('.mobile-filter__item').forEach((item) => item.remove());

  updateFilterCounter();
};

/**
 * Add click event to remove filter element
 */
const addEventClearFilter = () => {
  $Qll('.clear-filter-js').forEach((element) => {
    element.addEventListener('click', clearFilterAll);
  });
};

/**
 * Update the filter counter to mobile view
 */
const updateFilterCounter = () => {
  const counterElement = $Q('#filter_counter');
  const counterActiveFilters = [
    ...document.querySelectorAll('.mobile-filter__item'),
  ].filter((item) => item.style.display !== 'none').length;

  if (counterActiveFilters > 0) {
    counterElement.innerHTML = `(${counterActiveFilters})`;
  } else {
    counterElement.innerHTML = '';
  }
};

const addHeaderFiltersMobile = () => {
  const node = $Q('.mobile-filter__item');
  const headerSection = $Q('.mobile-filter');
  $Qll('.input-check').forEach((item) => {
    item.addEventListener('change', (e) => {
      if (e.target.checked) {
        const newNode = node.cloneNode(true);

        $Q('.title', newNode).innerHTML = item.value;
        newNode.dataset.name = item.name;
        newNode.dataset.value = item.value;
        newNode.removeAttribute('style');

        headerSection.appendChild(newNode);

        $Q('svg', newNode).addEventListener('click', () => {
          // ! Query selector fails to find the object by id
          // ! because the ID has a dot in the string
          document.getElementById(item.id).checked = false;
          headerSection.removeChild(newNode);

          updateFilterCounter();
          prepareFilteringParameter();
        });

        updateFilterCounter();
      } else {
        const currentNode = $Q(
          `.mobile-filter .mobile-filter__item[data-value="${item.value}"]`
        );
        currentNode.parentNode.removeChild(currentNode);

        updateFilterCounter();
      }
    });
  });
};

/**
 *init filter collection or restar event filter
 */
export const initFilterCollections = () => {
  rangeFilters();
  addEventClickFiltering();
  addEventClearFilter();
  if (isMobile()) {
    addHeaderFiltersMobile();
  }
};
